import type {BehaviorRowProps} from './index';

/**
 * Generates a unique key for inline filters on a given metric. This key is used to identify
 * draggable and droppable zones in the query builder
 *
 *  - entry._idx -- represents the metric entry in the QB
 * - props.behaviorIndex -- if defined, represents a nested behavior inside a metric
 * - props.index -- represents the sub-behavior index inside a metric (an event selection)
 */
export function getInlineFiltersKey(props: BehaviorRowProps) {
  return `${props.entry._idx}-${props.behaviorIndex ?? props.index}-inline-filters`;
}
